// Core React and utilities
import React, { useState } from "react";
import { Link } from "react-router-dom";
// Component styles and assets
import "./CardsSection.css";
import bullet from "../../../assets/images/growthBullet.svg";
import accordianClose from "../../../assets/images/accordian-close.svg";
import accordianOpen from "../../../assets/images/accordian-open.svg";
// Image mappings for categories
import { pix } from "../../../constants/cardsImages";

function CardsSections({ cardsData }) {
  // ... state and local declarations ...
  const [toggleId, setToggleId] = useState("");
  var area = "all";
  var survey = "all";

  /**
   * Handles accordion toggle functionality
   * Closes current section if already open, opens new section if different
  */
  const handleToggle = async (id) => {
    if (toggleId === id) setToggleId("");
    else setToggleId(id);
  };

  return (
    <div className="metrices3-grid">
      {cardsData &&
        Object.keys(cardsData)?.map((l1, key) => (
          <div className="metrices3-card" key={key}>
            <div className="metrices3-card-header">
              <div className="icon-wrapper">
                <img className="card-icon" src={pix[l1]} alt="" />
              </div>
              <h3 id={key} className="level1" title={l1}>
                {/* Main headings of the cards. example: Socio-Economic Status (SES) */}
                {l1}
              </h3>
            </div>
            <div className="accordion">
              {Object.keys(cardsData[l1])?.map((l2, key2) => {
                return (
                  cardsData[l1][l2].length > 0 && (
                    <div key={key2} onClick={() => handleToggle(cardsData[l1][l2][0]["id"])}>
                      <div className="l2-heading-wrapper pointer">
                        {/* Ensures what arrow type to be shown for a sub-heading */}
                        {toggleId === cardsData[l1][l2][0]["id"] ? (
                          <img src={accordianOpen} alt="" className="accordian-icon" />
                        ) : (
                          <img src={accordianClose} alt="" className="accordian-icon" />
                        )}
                        <h4
                          className={`accordion-toggle ${
                            toggleId === cardsData[l1][l2][0]["id"]
                              ? " selected-accordion-title"
                              : ""
                          }`}
                          id={key2}
                        >
                          {/* Sub-heading of the card. example: Household Characteristics */}
                          {l2}
                        </h4>
                      </div>
                      <div
                        className={
                          toggleId === cardsData[l1][l2][0]["id"]
                            ? "accordion-content open-view"
                            : "accordion-content"
                        }
                      >
                        <ul data-link={key2}>
                          {cardsData[l1][l2].map((l3, key3) => {
                            if (
                              (area === "all" && survey === "all") ||
                              (l3.level.indexOf(area) !== -1 &&
                                survey.toLowerCase() === "all") ||
                              (l3.level.indexOf(area) !== -1 &&
                                survey.toLowerCase() ===
                                  l3.source.toLowerCase()) ||
                              (area === "all" &&
                                survey.toLowerCase() ===
                                  l3.source.toLowerCase())
                            ) {
                              return (
                                <div className="l3-wrapper" key={key3}>
                                  <img className="l3-bullet" src={bullet} alt="" />
                                  <li className="section-links" key={key3}>
                                    <Link
                                      className="searchid l3-para"
                                      data-sfid={l3.id}
                                      to={"/data-portal?sf=" + l3.id}
                                    >
                                      {/* Variable Name of the Sub-heading of the card. example: Whether the household owns land usable for agriculture, by sector and religion (Source: NFHS) */}
                                      {l3["variable_name"].replace("]", "") +
                                        " (Source: " +
                                        l3["source"] +
                                        ")"}
                                    </Link>
                                    {/* Shows district or state badge by fetching the level array. */}
                                    <span className="badge-wrappper">
                                      {l3["level"] &&
                                        l3["level"].map((k) => {
                                          if (k.toLowerCase() !== "india") {
                                            return (
                                              <span
                                                className="card-badge"
                                                key={k}
                                              >
                                                {k.toLowerCase()}
                                              </span>
                                            );
                                          }
                                          return null;
                                        })}
                                    </span>
                                  </li>
                                </div>
                              );
                            }
                            return null;
                          })}
                        </ul>
                      </div>
                      <div className="line-separtor"></div>
                    </div>
                  )
                );
              })}
            </div>
          </div>
        ))}
    </div>
  );
}

// Memoize component to prevent unnecessary re-renders
export default React.memo(CardsSections);
